import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Field, fieldInputCls } from "@/components/Field";
import { useT } from "@/lib/i18n";
import { useSettings } from "@/context/SettingsContext";
import { TYRES } from "@/lib/format";
import { MultiPick } from "@/components/MultiPick";

const Pick = ({ label, value, onChange, options, allLabel, testid }) => (
  <Field label={label}>
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger data-testid={testid} className={fieldInputCls}><SelectValue /></SelectTrigger>
      <SelectContent>
        {allLabel && <SelectItem value="all">{allLabel}</SelectItem>}
        {options.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testid}-option-${v}`}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
  </Field>
);

export const PressureFilters = ({ f, setF, tracks, meta, eventOpts, dayOpts }) => {
  const { t } = useT();
  const hideCat = useSettings().settings.hide_categories;
  const set = (k) => (v) => setF({ ...f, [k]: v });
  const pairs = (list) => list.map((x) => [x, x]);
  return (
    <div data-testid="pressure-filters" className="bg-[#12141C] border border-[#282D3D] rounded-sm p-4 space-y-3 mb-6">
      <div className="font-mono text-[10px] uppercase tracking-widest text-[#FFB800]">{t("analysis_period")}</div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end pb-3 border-b border-[#282D3D]">
        <Pick label={t("track")} testid="pressure-track-select" value={f.track} onChange={(v) => setF({ ...f, track: v, events: [], days: [] })} options={pairs(tracks)} />
        <MultiPick label={t("events_filter")} testid="pressure-events-select" options={eventOpts} value={f.events} onChange={(v) => setF({ ...f, events: v, days: [] })}
          allLabel={t("pick_event")} countLabel={t("events_selected")} required />
        <MultiPick label={t("days_filter")} testid="pressure-days-select" options={dayOpts} value={f.days} onChange={set("days")}
          allLabel={t("all_days")} countLabel={t("days_selected")} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1.2fr_auto_auto] gap-3 items-end">
      <Pick label={t("driver")} testid="pressure-driver-select" value={f.driver} onChange={set("driver")} options={pairs(meta.drivers)} allLabel={t("all_drivers")} />
      {!hideCat && <Pick label={t("category")} testid="pressure-category-select" value={f.category} onChange={set("category")} options={pairs(meta.categories)} allLabel={t("all_categories")} />}
      <Pick label={t("tyres")} testid="pressure-tyre-select" value={f.tyre} onChange={set("tyre")} options={TYRES.map((p) => [p, t(`tyre_${p}`)])} allLabel={t("all_tyres")} />
      <Pick label={t("tyre_model_filter")} testid="pressure-model-select" value={f.model} onChange={set("model")}
        options={(meta.tyres || []).map((x) => [`${x.brand}|${x.model}`, [x.brand, x.model].filter(Boolean).join(" · ")])} allLabel={t("all_tyre_models")} />
      <div className="flex h-10 border border-[#282D3D] rounded-sm overflow-hidden font-mono text-xs">
        {["bar", "psi"].map((u) => (
          <button key={u} type="button" data-testid={`pressure-chart-unit-${u}`} onClick={() => setF({ ...f, unit: u })}
            className={`px-3 uppercase transition-colors duration-200 ${f.unit === u ? "bg-[#FF3B30] text-white" : "text-slate-400 hover:text-white"}`}>{u}</button>
        ))}
      </div>
      <label className="flex items-center gap-2 h-10 font-mono text-xs uppercase text-slate-400 cursor-pointer">
        <Switch data-testid="pressure-trend-switch" checked={f.trend} onCheckedChange={set("trend")} className="data-[state=checked]:bg-[#FFB800]" />
        {t("trend")}
      </label>
      </div>
    </div>
  );
};
